import { DatePicker, Upload, Typography, Modal, Row, Col, Button, Form, Radio, Alert, Input, Select, Space, Switch, message, Checkbox, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { DeleteOutlined, InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import AdminModal from './AdminModal';
import SmallCalendar from '../../schedule_timeline/SmallCalendar';
const { RangePicker } = DatePicker;
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const AdminClassSchedulingModal = ({
    propsForm,
    ...props
}) => {
    // const [class_date, set_class_date] = useState([]);
    // const [class_week, set_class_week] = useState([]);
    const [is_resign, set_is_resign] = useState(true);
    const [environment, set_environment] = useState([]);
    const [class_name, set_class_name] = useState();
    const [count, setCount] = useState(0);
    const [show, set_show] = useState(false);
    const [classTime, setClassTime] = useState([]);
    const [classWeek, setClassWeek] = useState([])
    const [holiday, set_holiday] = useState([]);
    const [lesson_category, set_lesson_category] = useState([]);
    const [teacher_list, set_teahcer_list] = useState([]);
    const [smallCalendarKey, setSmallCalendarKey] = useState(0)
    const [form] = Form.useForm();
    const [classTimeRange, setClassTimeRange] = useState([])
    const [weekdayValue, setWeekdayValue] = useState([])
    const onHolidayChange = (e) => {
        let selected_week = []
        e && e.map((item, i) => {
            selected_week.push({
                ...item,
                text: `${item.date}(${item.week})為${item.description}`,
            })
        })
        if (props.editcard.class_time_end_default != undefined && props.editcard.class_time_end_default != '' &&
            props.editcard.class_time_start_default != undefined && props.editcard.class_time_start_default != "") {
            set_holiday(selected_week);
        }
        set_holiday(selected_week);

    }
    useEffect(() => {
        if (holiday.length !== 0) {
            set_show(true);
        }
    }, [holiday])
    useEffect(() => {
        setSmallCalendarKey(pre => pre + 1)
    }, [props.class_week, props.class_date])
    useEffect(() => {
        if (props.editcard.class_week != undefined && props.editcard.class_week.length != 0) {
            let data_tmp = [];
            props.editcard.class_week.map((item, i) => {
                let data_json_tmp = {};
                data_json_tmp['key'] = i;
                data_json_tmp['id'] = item.emergency_contact_id;
                data_json_tmp['day'] = item.day;
                setCount(count + 1);
                data_tmp.push(data_json_tmp);
            })
            props.set_class_week(data_tmp)
        }
    }, [props.editcard.class_week])
    useEffect(() => {
        get_teacher();
        axios
            .get('/cramSchool/api/lesson')
            .then((response) => {
                let data = response.data?.data
                set_lesson_category(
                    data.map(map_item => {
                        return {
                            value: map_item.lesson_id,
                            label: map_item.name,
                        };
                    }))
            })
        axios
            .get('/cramSchool/api/surrounding')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['surrounding_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_environment(data_tmp);
            })
        axios
            .get('/cramSchool/api/class_time')
            .then((response) => {
                setClassTime(response.data.data.map(map_item => {
                    return {
                        value: map_item?.time_id,
                        label: `${map_item['time_start']}-${map_item['time_end']}`,
                    };
                }))

            })
        axios
            .get('/cramSchool/api/class/coding')
            .then((response) => {
                setClassWeek(response.data.first.map(map_item => {
                    return {
                        value: map_item.id,
                        label: `${map_item['week_name']}`,
                    };
                }))
            })
    }, [])
    const get_teacher = () => {
        axios
            .get('/cramSchool/api/teacher', { params: { is_resign: true } })
            .then((response) => {
                let data_tmp = response.data.data.filter(item => item.name != null);
                set_teahcer_list(data_tmp.map(map_item => {
                    return {
                        value: map_item.teacher_id,
                        label: map_item.name,
                    };
                }))
            })
    }
    const onFinish = (values) => {
        let grade_class_id = values?.grade_class_id
        let teacher_data = values?.teacher_id.map((value) => {
            return {
                teacher_id: value
            }
        })
        let class_time_start_default = dayjs(values?.class_time[0]).format("YYYY-MM-DD")
        let class_time_end_default = dayjs(values?.class_time[1]).format("YYYY-MM-DD")
        let admission_class_time_start_default = dayjs(values?.admission_class_time[0]).format("YYYY-MM-DD")
        let admission_class_time_end_default = dayjs(values?.admission_class_time[1]).format("YYYY-MM-DD")
        let week_time_data = values?.week_time_data.map((value) => {
            return {
                ...value,
                grade_class_week_time_id: values?.grade_class_week_time_id,
                grade_class_id: grade_class_id,
            }
        })
        let lesson_class_data = [{ lesson_id: values?.lesson_id }]
        delete values.teacher_id
        delete values.lesson_id
        delete values.admission_class_time
        delete values.class_time
        delete values.grade_class_id

        values = {
            ...values,
            lesson_class_data,
            teacher_data,
            class_time_start_default,
            class_time_end_default,
            week_time_data,
            admission_class_time_start_default,
            admission_class_time_end_default
        }
        if (props.edit) {
            props.handleEdit(values)
        }
        else {
            props.handleSubmit(values)
        }


    }
    const onWeekTimeDataChange = () => {
        let week_time_data = []

        if (propsForm) {
            week_time_data = propsForm.getFieldValue("week_time_data") ?? []
        }
        else {
            week_time_data = form.getFieldValue("week_time_data") ?? []

        }
        week_time_data.reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []);
        setWeekdayValue((pre) => {
            return week_time_data.map((value) => {
                return value?.week_id % 7
            })
        })

        setSmallCalendarKey(pre => pre + 1)
    }

    useEffect(() => {
        if (props.open) {
            let newClassTimeRange = []
            if (propsForm) {
                let class_time_start_default = propsForm.getFieldValue("class_time_start_default")
                let class_time_end_default = propsForm.getFieldValue("class_time_end_default")
                newClassTimeRange = [class_time_start_default, class_time_end_default]
            }
            else {
                let class_time_start_default = propsForm.getFieldValue("class_time_start_default")
                let class_time_end_default = propsForm.getFieldValue("class_time_end_default")
                newClassTimeRange = [class_time_start_default, class_time_end_default]
            }
            setClassTimeRange(newClassTimeRange)
            onWeekTimeDataChange()
        }
    }, [props.open])
    useEffect(() => {
        get_teacher();
    }, [is_resign])
   
    return (
        <>
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={600}
                footer={false}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 65, left: 78 }} >{props.title}</Col>
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 90, left: 60 }} >課程編排</Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Form
                                    labelCol={
                                        {
                                            lg: {
                                                span: 6,
                                            },
                                            sm: {
                                                span: 6,
                                            },
                                        }}
                                    wrapperCol={
                                        {
                                            lg: {
                                                span: 14,
                                            },
                                            sm: {
                                                span: 16,
                                            },
                                        }
                                    }

                                    form={propsForm ? propsForm : form}
                                    onFinish={onFinish}
                                    scrollToFirstError
                                >
                                    <Row gutter={[8, 8]} align={'middle'}>
                                        <Form.Item
                                            name={"grade_class_id"}
                                        >
                                        </Form.Item>
                                        <Col span={24}>

                                            <Form.Item
                                                label={"課程名稱"}
                                                name={"lesson_id"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇課程（必填）"
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    style={{
                                                        width: 300,
                                                    }}
                                                    placeholder='請選擇課程（必填）'
                                                    options={lesson_category}>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={"課程編號"}
                                                name={"name_serial"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請填寫編號（必填"
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    style={{
                                                        width: 300,
                                                    }}
                                                    labelInValue
                                                    placeholder='請填寫編號（必填）'
                                                >
                                                </Input>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={"班級名稱"}
                                                name={"name"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請填寫編號（必填"
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    style={{
                                                        width: 200,
                                                    }}
                                                    placeholder='請輸入班級名稱（必填）'
                                                >
                                                </Input>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={"老師列表"}
                                            >
                                                <Checkbox
                                                    checked={is_resign ? true : false}
                                                >
                                                    隱藏離職人員
                                                </Checkbox>
                                            </Form.Item>

                                            <Form.Item
                                                label={"授課老師"}
                                                name={"teacher_id"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇教師（必填)"
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    mode='multiple'
                                                    options={teacher_list}
                                                >

                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={24}>

                                            <Form.Item
                                                label={"招生日期"}
                                                name={"admission_class_time"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇招生日期（必填)"
                                                    }
                                                ]}
                                            >
                                                <RangePicker
                                                    format={"YYYY-MM-DD"}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={24}>

                                            <Form.Item
                                                label={"招生人數"}
                                                name={"upper_limit_people"}
                                            >
                                                <InputNumber
                                                    min={0}
                                                ></InputNumber>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>

                                            <Form.Item
                                                label={"授課日期"}
                                                name={"class_time"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "請選擇授課日期（必填)"
                                                    }
                                                ]}
                                            >
                                                <RangePicker
                                                    format={"YYYY-MM-DD"}
                                                    onChange={(_, dateString) => {
                                                        setClassTimeRange(dateString)
                                                        setSmallCalendarKey((pre => pre + 1))
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>

                                            <Form.Item
                                                label={"授課教室"}
                                                name={"surrounding_id"}
                                            >
                                                <Select
                                                    placeholder='請選擇授課教室'
                                                    options={environment}
                                                >
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={"授課時間"}
                                                wrapperCol={18}
                                            >
                                                <Form.List
                                                    name={"week_time_data"}
                                                >
                                                    {(fields, { add, remove }) => (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                rowGap: 16,
                                                                flexDirection: 'column',
                                                            }}
                                                        >
                                                            <Button
                                                                type='primary'
                                                                onClick={() => add()}
                                                            >新增授課時間
                                                            </Button>
                                                            {fields.map((field) => (
                                                                <Space>
                                                                    <Form.Item
                                                                        hidden
                                                                        name={[field.name, "grade_class_week_time_id"]}
                                                                    >
                                                                        <Input />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        label="星期"
                                                                        name={[field.name, 'week_id']}
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "請選擇 （必填)"
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            style={{
                                                                                width: 100,
                                                                            }}
                                                                            options={classWeek}
                                                                            onChange={(e) => {
                                                                                onWeekTimeDataChange()
                                                                            }}
                                                                        ></Select>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        label="時間段"
                                                                        name={[field.name, 'time_id']}
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "請選擇 （必填)"
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            style={{ width: 150 }}
                                                                            options={classTime}
                                                                        />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        name={[field.name, "grade_class_week_time_id"]}
                                                                    >

                                                                    </Form.Item>
                                                                    <Form.Item>
                                                                        <DeleteOutlined
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                remove(field.name);
                                                                                onWeekTimeDataChange();
                                                                            }}
                                                                        />
                                                                    </Form.Item>


                                                                </Space>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Form.List>
                                            </Form.Item>
                                        </Col>
                                        {show &&
                                            holiday && holiday.map((value, i) => {
                                                return (
                                                    < Col span={24}>
                                                        <Alert message={value.text} type="warning" showIcon
                                                            action={
                                                                <Space direction="vertical">
                                                                    <Button size="small" type="primary">
                                                                        停課
                                                                    </Button>
                                                                    {/* <Button size="small" danger ghost>
                                                                        調課
                                                                    </Button> */}
                                                                </Space>
                                                            } />
                                                    </Col>
                                                )
                                            })
                                        }

                                        <Form.Item
                                            label={"授課預覽"}
                                        >
                                            <SmallCalendar
                                                key={smallCalendarKey}
                                                onHolidayChange={onHolidayChange}
                                                date_range_values={classTimeRange}  // RangePicker 的 dateString value
                                                default_weekday_value={weekdayValue}  // 星期幾：0是星期天，1是星期一，以此類推... 6是星期六
                                                circle_item={[]}
                                                class_name_value={class_name}  // 課程名稱
                                                make_up_date_value={[{
                                                    "is_make_up": "1",
                                                    "original_date": "2023-09-29",
                                                    "make_up_date": "2023-09-20"
                                                },
                                                {
                                                    "is_make_up": "0",
                                                    "original_date": "2023-10-10"
                                                }
                                                ]}
                                            />
                                            {/* )} */}
                                        </Form.Item>
                                    </Row >
                                </Form>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => {
                                                propsForm ? propsForm.submit() : form.submit()
                                            }}
                                            size='large'
                                            style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }}
                                            block>
                                            {props.edit ? '修改' : '送出'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )
}
export default AdminClassSchedulingModal; 